import { btnCancel, btnOne, label, title } from "../utils/style";


function ConfirmationModal({header, body, cancelHandler, confirmHandler, confirmText}) {


    return(
        <div className="flex w-screen h-screen fixed top-0 left-0 items-center justify-center bg-black z-50 px-8 bg-opacity-50">
            <div className="rounded-xl px-4 py-6 bg-white w-full text-center">
                <div className={title}>{header}</div>
                <div className={label}>{body}</div>
                <div className="flex justify-between gap-4 mt-4">
                    <button className={btnCancel} onClick={() => cancelHandler(false)}>Cancel</button>
                    <button className={btnOne} onClick={() => {confirmHandler(); cancelHandler(false)}}>{confirmText || header}</button>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationModal;